// Reads a recent-purchase timestamp written by the host app immediately after a
// purchase. When present, video API calls (GetVideo / BatchGetVideos) send it as
// recent_purchase_time so the backend knows to look for an entitlement that may
// not have fully propagated yet.
//
// Contract (shared with the host app's writer):
//   localStorage key: "recentPurchaseTime"
//   value: JSON { time: RFC3339 string, expiresAt: epoch ms }

const RECENT_PURCHASE_KEY = 'recentPurchaseTime';

interface StoredRecentPurchase {
  time: string;
  expiresAt: number;
}

// Returns the RFC3339 purchase timestamp if a non-expired recent purchase exists,
// otherwise undefined (clearing the stale entry on the way out).
export const getRecentPurchaseTime = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;
  try {
    const raw = localStorage.getItem(RECENT_PURCHASE_KEY);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw) as StoredRecentPurchase;
    if (!parsed?.time || !parsed?.expiresAt || Date.now() > parsed.expiresAt) {
      localStorage.removeItem(RECENT_PURCHASE_KEY);
      return undefined;
    }
    return parsed.time;
  } catch {
    return undefined;
  }
};
